import React, { Fragment, Component } from "react";
import { properties } from '../../../constants/Propertise';
import moment from "moment";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "react-picky/dist/picky.css";
import InlineError from '../../InlineError';

class Filter extends Component {
    constructor(props) {
        super(props);
        let today = new Date();
        let lastWeekDate = new Date(today.setDate(today.getDate() - properties.pastDay));
        this.state = {
            startDate: moment(lastWeekDate),
            endDate: moment(),
            // startDate: moment(lastWeekDate).format(properties.dateFormat),
            // endDate: moment().format(properties.dateFormat),
            errors: {},
            isValid: false,
            isPending: true,
            isError: false,
            isSucess: false
        }
    }

    componentDidMount = () => {
        const filterCriteria = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
        }
        this.props.filterList(filterCriteria);
    }

    startDateIsValid = (current) => {
        if (this.state.endDate) {
            let endDate = this.state.endDate;
            let threeMonthsAgo = moment().subtract(90, "day");
            return current.isAfter(threeMonthsAgo) && current.isBefore(endDate);
        }
        else {
            let threeMonthsAgo = moment().subtract(90, "day");
            let today = moment();
            return current.isAfter(threeMonthsAgo) && current.isBefore(today);
        }
    }

    endDateIsValid = (current) => {
        if (this.state.startDate) {
            let startDate = this.state.startDate;
            let dayBeforeStartDate = moment(Date.parse(startDate)).subtract(1, "day");
            let today = moment();
            return current.isAfter(dayBeforeStartDate) && current.isBefore(today);
        }
        else {
            let today = moment();
            let threeMonthsAgo = moment().subtract(90, "day");
            return current.isAfter(threeMonthsAgo) && current.isBefore(today);
        }
    }

    handleDateChange(dateName, dateValue) {
        let { startDate, endDate } = this.state;
        if (dateName === "startDate") {
            // startDate = moment(dateValue, properties.dateFormat).format(properties.dateFormat);
            startDate = dateValue
        }

        if (dateName === "endDate") {
            // endDate = moment(dateValue, properties.dateFormat).format(properties.dateFormat);
            endDate = dateValue
        }
        this.setState({ startDate, endDate });
    }

    setFilter = () => {
        const filterCriteria = {
            startDate: (this.state.startDate).format('YYYY-MM-DD'),
            endDate: (this.state.endDate).format('YYYY-MM-DD'),
        }

        // let errors = this.validate(filterCriteria);

        this.setState({
            // errors: errors,
            isValid: true
        }, () => {
            if (Object.keys(this.state.errors).length === 0) {
                this.props.filterList(filterCriteria);
            }
        });
    }

    // validate = (formData) => {
    //     console.log(formData);
    //     let errors = {};
    //     let start = moment(formData.startDate).format(properties.dateFormatFromDB);
    //     let end = moment(formData.endDate).format(properties.dateFormatFromDB);

    //     if (Date.parse(start.toString()) > Date.parse(end.toString())) {
    //         errors.startDate = properties.startDateShouldBeLessThanEndDate;
    //     }
    //     return errors;
    // }

    resetFilter = () => {
        let today = new Date();
        let lastWeekDate = new Date(today.setDate(today.getDate() - properties.pastDay));

        this.setState({
            startDate: moment(lastWeekDate),
            endDate: moment(),
        }, () => {
            const filterCriteria = {
                startDate: (this.state.startDate).format('YYYY-MM-DD'),
                endDate: (this.state.endDate).format('YYYY-MM-DD'),
            }
            this.props.resetFilter(filterCriteria);
        });
    }

    render() {
        return (
            <Fragment>
                <div className="form-row">
                    <div className="col-md-3 mb-3">
                        <label className="feildName d-flex">{properties.startDateText}<span className="required">*</span>:</label>
                        <DateTime
                            id="startDate"
                            name="startDate"
                            selected={this.state.startDate}
                            value={this.state.startDate}
                            dateFormat={properties.dateFormat}
                            timeFormat={false}
                            closeOnSelect={true}
                            onChange={date =>
                                this.handleDateChange("startDate", date)
                            }
                            isValidDate={this.startDateIsValid}
                        />
                        {
                            this.state.errors.startDate && (
                                <InlineError text={this.state.errors.startDate} />
                            )
                        }
                    </div>
                    <div className="col-md-3 mb-3">
                        <label className="feildName d-flex">{properties.endDateText}<span className="required">*</span>:</label>
                        <DateTime
                            id="endDate"
                            name="endDate"
                            selected={this.state.endDate}
                            value={this.state.endDate}
                            dateFormat={properties.dateFormat}
                            timeFormat={false}
                            closeOnSelect={true}
                            onChange={date =>
                                this.handleDateChange("endDate", date)
                            }
                            isValidDate={this.endDateIsValid}
                        />
                    </div>
                    <div className="col-md-4 mb-3 d-flex align-items-end">
                        <label className="feildName">&nbsp;</label>
                        <button className="btn btn-primary" style={{ marginBottom: "3px" }} onClick={this.setFilter}>
                            {properties.filterButtonText}
                        </button>&nbsp;&nbsp;&nbsp;
                        <button className="btn btn-secondary" style={{ marginBottom: "3px" }} onClick={this.resetFilter}>
                            {properties.resetButtonText}
                        </button>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Filter;